import { useBackendAuth } from '../../hooks/useAuth';
import { Menu } from 'lucide-react';

interface AdminHeaderProps {
    onMenuClick?: () => void;
    showMenuButton?: boolean;
}

const AdminHeader = ({ onMenuClick, showMenuButton = false }: AdminHeaderProps) => {
    const { user, logout, isAdmin } = useBackendAuth();

    const handleLogout = () => {
        // logout() already navigates to /admin/login with replace
        void logout();
    };

    // Buttons are ONLY visible when logged in AND is admin
    const isLoggedInAsAdmin = user && isAdmin();

    return (
        <header className="fixed top-0 right-0 left-0 z-[60] bg-indigo-600 shadow-lg">
            <div className="relative mx-auto flex h-16 max-w-7xl items-center gap-2 px-3 sm:px-4">
                {showMenuButton && isLoggedInAsAdmin && (
                    <button
                        type="button"
                        onClick={onMenuClick}
                        className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-lg text-white hover:bg-indigo-500 lg:hidden"
                        aria-label="Open admin menu"
                    >
                        <Menu size={24} />
                    </button>
                )}
                {isLoggedInAsAdmin && (
                    <div className="hidden flex-1 justify-start sm:flex">
                        {user && (
                            <a
                                href="/home"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="rounded bg-white px-3 py-2 text-sm text-indigo-600 transition-colors hover:bg-indigo-50 sm:px-4"
                            >
                                Go to Webshop
                            </a>
                        )}
                    </div>
                )}
                <h1 className="absolute left-1/2 -translate-x-1/2 text-lg font-bold text-white sm:text-2xl">
                    Admin Panel
                </h1>
                {isLoggedInAsAdmin && (
                    <div className="ml-auto flex flex-1 justify-end">
                        {user && (
                            <button
                                type="button"
                                onClick={handleLogout}
                                className="rounded bg-white px-3 py-2 text-sm text-indigo-600 transition-colors hover:bg-indigo-50 sm:px-4"
                            >
                                Logout
                            </button>
                        )}
                    </div>
                )}
            </div>
        </header>
    );
};

export default AdminHeader;
